// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown {\n  border-radius: 2px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 1px rgba(0, 0, 0, 0.05) !important;\n}\n.el-select-dropdown__item {\n  color: #7C7D80;\n  padding-left: 10px !important;\n}\n.el-select-dropdown__item.hover {\n  background-color: #FAFAFA;\n}\n.el-select-dropdown__item.selected {\n  color: #17181A;\n}\n", ""]);
// Exports
module.exports = exports;
